/**
 * desc : 图片展示样式-重叠
 */
<template>
  <section class="comp-image-tiled" :style="`background-color: ${backgroundColor}`">
    <div data-itemtext="图片类组件" :data-itemotherinfo="getLink(imgs[0])" @click="clickHandle(imgs[0], 0)">
      <img v-if="imgs[1] && imgs[1].imgLink && imgs[1].show" class="cover" width="100%" :src="`${picHost+imgs[1].imgLink}`" @load="loadHandler" />
      <img width="100%" :src="`${picHost+imgs[0].imgLink}`" @load="loadHandler" v-if="imgs[0] && imgs[0].imgLink && imgs[0].show"/>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import mixin from './image_mixin.js'
import { eventBus } from '@/utils' 

export default {
  mixins: [mixin],
  computed: {
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      }
    }
  },
  methods: {
    loadHandler($event) {
      eventBus.$emit('imageOnload')
    }
  }
}
</script>
<style lang="scss" scoped>
.comp-image-tiled {
  width: 100%;
  display: flex;
  > div {
    width: 100%;
    font-size: 0;
    position: relative;
  }
  img {
    cursor: pointer;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;

    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .cover {
    position: relative;
    z-index: 0;
  }
}
</style>
